import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InstancesMgmtComponent} from './instances-mgmt.component';
import {InstancesMgmtRoutingModule} from 'src/app/main/instances-mgmt/instances-mgmt-routing.module';
import {BreadcrumbModule} from '../../components/breadcrumb/breadcrumb.module';
import {SharedModule} from 'src/app/shared/shared.module';
import {TableModule} from 'src/app/table/table.module';
import { IconsModule } from '../../icons/icons.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatCardModule} from '@angular/material/card';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {InstanceEndpointsComponent} from './instance-endpoints/instance-endpoints.component';
import {SidenavHeaderModule} from 'src/app/components/sidenav-header/sidenav-header.module';
import {ClipboardModule} from '@angular/cdk/clipboard';
import { FormsModule  } from '@angular/forms';
import {InstancesDetailsComponent} from './instances-details/instances-details.component';
import {MatDividerModule} from '@angular/material/divider';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {PaginatorModule} from 'src/app/components/paginator/paginator.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import { ColumnFilterComponent } from './column-filter/column-filter.component';
import {DefaultFilterModule} from '../../components/default-filter/default-filter.module';
import { ToolbarModule } from 'src/app/layout/toolbar/toolbar.module';
import {MatMenuModule} from '@angular/material/menu';
import { InstanceDetailsModule } from 'src/app/components/instance-details/instance-details.module';
import { SearchFilterModule } from 'src/app/components/search-filter/search-filter.module';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';

@NgModule({
  declarations: [
    InstancesMgmtComponent,
    InstanceEndpointsComponent,
    InstancesDetailsComponent,
    ColumnFilterComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    BreadcrumbModule,
    InstancesMgmtRoutingModule,
    TableModule,
    IconsModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatSelectModule,
    MatInputModule,
    SidenavHeaderModule,
    ClipboardModule,
    FormsModule,
    MatDividerModule,
    MatTabsModule,
    MatExpansionModule,
    MatProgressBarModule,
    PaginatorModule,
    MatTooltipModule,
    DefaultFilterModule,
    ToolbarModule,
    MatMenuModule,
    InstanceDetailsModule,
    SearchFilterModule,
    MatDatepickerModule,
    MatNativeDateModule
  ]
})
export class InstancesMgmtModule {
}
